// Generated by scripts/mdi/import-questionnaires.mjs.
import { mdiAlopeciaMinoxidil } from './AlopeciaMinoxidil/flow';
import { mdiB12InjectionIntake } from './B12InjectionIntake/flow';
import { mdiB12Refill } from './B12Refill/flow';
import { mdiBPC157 } from './BPC157/flow';
import { mdiBPC157ThymosinBeta4 } from './BPC157ThymosinBeta4/flow';
import { mdiCJC1295Ipamorelin } from './CJC1295Ipamorelin/flow';
import { mdiEmideltideDSIP } from './EmideltideDSIP/flow';
import { mdiEpithalon } from './Epithalon/flow';
import { mdiErectileDysfunctionInitial } from './ErectileDysfunctionInitial/flow';
import { mdiErectileDysfunctionRefill } from './ErectileDysfunctionRefill/flow';
import { mdiFinasterideDutasterideWomensMEN } from './FinasterideDutasterideWomensMEN/flow';
import { mdiGlutathioneInitial } from './GlutathioneInitial/flow';
import { mdiGlutathioneRefill } from './GlutathioneRefill/flow';
import { mdiKPV } from './KPV/flow';
import { mdiMOTSC } from './MOTSC/flow';
import { mdiMinoxidilFinasterideBiotinMenWomen } from './MinoxidilFinasterideBiotinMenWomen/flow';
import { mdiMinoxidilFinasterideMenWomen } from './MinoxidilFinasterideMenWomen/flow';
import { mdiMinoxidilFinasterideTretMenWomen } from './MinoxidilFinasterideTretMenWomen/flow';
import { mdiNADInitial } from './NADInitial/flow';
import { mdiNADRefill } from './NADRefill/flow';
import { mdiPT141BremelanotideInjectionMenAndWomen } from './PT141BremelanotideInjectionMenAndWomen/flow';
import { mdiSemaglutideB6Initial } from './SemaglutideB6Initial/flow';
import { mdiSemaglutideB6Refill } from './SemaglutideB6Refill/flow';
import { mdiSermorelinRefill } from './SermorelinRefill/flow';
import { mdiStandardizedSermorelinIntake } from './StandardizedSermorelinIntake/flow';
import { mdiTesamorelinInitialSystemic } from './TesamorelinInitialSystemic/flow';
import { mdiTesamorelinRefillSystemic } from './TesamorelinRefillSystemic/flow';
import { mdiThymosinBeta4 } from './ThymosinBeta4/flow';
import { mdiTirzepatideB6Initial } from './TirzepatideB6Initial/flow';
import { mdiTirzepatideB6Refill } from './TirzepatideB6Refill/flow';

const mdiFlows = {
  mdiAlopeciaMinoxidil,
  mdiB12InjectionIntake,
  mdiB12Refill,
  mdiBPC157,
  mdiBPC157ThymosinBeta4,
  mdiCJC1295Ipamorelin,
  mdiEmideltideDSIP,
  mdiEpithalon,
  mdiErectileDysfunctionInitial,
  mdiErectileDysfunctionRefill,
  mdiFinasterideDutasterideWomensMEN,
  mdiGlutathioneInitial,
  mdiGlutathioneRefill,
  mdiKPV,
  mdiMOTSC,
  mdiMinoxidilFinasterideBiotinMenWomen,
  mdiMinoxidilFinasterideMenWomen,
  mdiMinoxidilFinasterideTretMenWomen,
  mdiNADInitial,
  mdiNADRefill,
  mdiPT141BremelanotideInjectionMenAndWomen,
  mdiSemaglutideB6Initial,
  mdiSemaglutideB6Refill,
  mdiSermorelinRefill,
  mdiStandardizedSermorelinIntake,
  mdiTesamorelinInitialSystemic,
  mdiTesamorelinRefillSystemic,
  mdiThymosinBeta4,
  mdiTirzepatideB6Initial,
  mdiTirzepatideB6Refill
};

export default mdiFlows;
